import { KLAYO_COLORS } from '@/themes';
import { Box, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from './Button';
import { Dialog } from './dialogs/Dialog';

interface EmployeeAccessLevelInfoDialogProps {
  translate: (key: string, params?: Record<string, unknown>) => string;
  theme: any;
  onClose: () => void;
  hideUpgradePrompt?: boolean;
  introText?: string;
}

export function EmployeeAccessLevelInfoDialog({
  translate,
  theme,
  onClose,
  hideUpgradePrompt,
  introText,
}: EmployeeAccessLevelInfoDialogProps) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Dialog
      open={true}
      theme={theme}
      title={translate('settingsViews.employees.accessLevelInfoDialog.title')}
      topCloseButton
      maxWidth='sm'
      onClose={onClose}
      closeButtonSx={{
        display: 'block',
      }}
      contentSx={{
        paddingBottom: { xs: '20px !important', md: '40px !important' },
      }}
    >
      <Stack spacing={3}>
        {introText && (
          <Typography variant='body1' color={KLAYO_COLORS.GreyGR900}>
            {introText}
          </Typography>
        )}
        <Stack spacing={0.5}>
          <Typography variant='body1' fontWeight={600}>
            {translate('settingsViews.employees.accessLevelInfoDialog.limitedAccessTitle')}
          </Typography>
          <Typography variant='body1' color={KLAYO_COLORS.GreyGR500}>
            {translate('settingsViews.employees.accessLevelInfoDialog.limitedAccessDesc')}
          </Typography>
        </Stack>
        <Stack spacing={0.5}>
          <Typography variant='body1' fontWeight={600}>
            {translate('settingsViews.employees.accessLevelInfoDialog.fullAccessTitle')}
          </Typography>
          <Typography variant='body1' color={KLAYO_COLORS.GreyGR500}>
            {translate('settingsViews.employees.accessLevelInfoDialog.fullAccessDesc')}
          </Typography>
        </Stack>
        {!hideUpgradePrompt && (
          <Box
            sx={{
              backgroundColor: KLAYO_COLORS.NeonBlueNB050,
              borderRadius: 2,
              padding: '20px 24px',
            }}
          >
            <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={2}>
              <Typography variant='body1' color={KLAYO_COLORS.GreyGR500} flex={1}>
                {translate('settingsViews.employees.accessLevelInfoDialog.needMoreSeats')}
              </Typography>
              <Button
                variant='outlined'
                label={translate('billing.upgradeNow')}
                onClick={() =>
                  navigate('/pricing-and-checkout', {
                    state: { from: location.pathname + location.search },
                  })
                }
              />
            </Stack>
          </Box>
        )}
      </Stack>
    </Dialog>
  );
}
